// Atomを管理するキー
// Atom: 状態の単位。
// Atom更新時にコンポーネントは再レンダリング
export enum AtomKeys {
    CAR_SCHOOL_ID_STATE = "carSchoolIdState",
    CAR_SCHOOL_NAME_STATE = "carSchoolNameState",
    DATE_FROM_STATE = "dateFromState",
    DATE_TO_STATE = "dateToState",
}
